
import { defineComponent } from 'vue'
import countTo from 'vue-count-to'
export default defineComponent({
  name: 'CommonCommunity',
  components: { countTo },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      startVal: 0,
    }
  },
  computed: {
    totalDiagrams() {
      const total = this.$store.state.diagrams?.total as number || 0;
      return this.simplifyNumber(total);
    },
    totalDesigners() {
      const total = this.$store.state.designers?.total as number || 0;
      return this.simplifyNumber(total);
    },
    totalDiagramsDisplay() {
      const value = this.totalDiagrams;
      return typeof value === 'number' ? Number(value.toFixed(1)) : 0;
    },
    totalDesignersDisplay() {
      const value = this.totalDesigners;
      return typeof value === 'number' ? Number(value.toFixed(1)) : 0;
    }
  },
  methods: {
    simplifyNumber(num: number): number | string {
      try {
        const units = ['', 'k', 'M'];
        let order = 0;
        let value = num;

        while (value >= 1000 && order < units.length - 1) {
          order++;
          value = value / 1000;
        }

        if (order === 0) {
          return num;
        }
        return value;
      } catch (error) {
        return 'N/A';
      }
    },
  },
})
